import { getToken } from "../utils/auth";
import { API_BASE_URL } from "./URL_Header";

const authHeaders = () => ({
  Authorization: `Bearer ${getToken()}`,
});

const buildQuery = (filters = {}) => {
  const params = new URLSearchParams();
  Object.entries(filters).forEach(([key, value]) => {
    if (value === undefined || value === null || value === "" || value === false) return;
    params.set(key, String(value));
  });
  const text = params.toString();
  return text ? `?${text}` : "";
};

async function readError(response) {
  try {
    const body = await response.json();
    return body.error || body.message || "Request failed";
  } catch {
    return "Request failed";
  }
}

export const fetchOrderActivityMeta = async () => {
  const response = await fetch(`${API_BASE_URL}/OrderActivity/meta`, { headers: authHeaders() });
  if (!response.ok) throw new Error(await readError(response));
  return response.json();
};

export const fetchOrderActivity = async (filters) => {
  const response = await fetch(`${API_BASE_URL}/OrderActivity${buildQuery(filters)}`, {
    headers: authHeaders(),
  });
  if (!response.ok) throw new Error(await readError(response));
  return response.json();
};

export const fetchOrderActivityDetail = async (actionId) => {
  const response = await fetch(`${API_BASE_URL}/OrderActivity/${actionId}`, {
    headers: authHeaders(),
  });
  if (!response.ok) throw new Error(await readError(response));
  return response.json();
};

export const exportOrderActivity = async (filters) => {
  const response = await fetch(`${API_BASE_URL}/OrderActivity/export${buildQuery(filters)}`, {
    headers: authHeaders(),
  });
  if (!response.ok) throw new Error(await readError(response));
  const blob = await response.blob();
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = "order-activity.csv";
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
};

export const restoreOrderActivity = async (actionId, orderIds, idempotencyKey) => {
  const response = await fetch(`${API_BASE_URL}/OrderActivity/restore`, {
    method: "POST",
    headers: {
      ...authHeaders(),
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ actionId, orderIds, idempotencyKey }),
  });
  if (!response.ok) throw new Error(await readError(response));
  return response.json();
};
